/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bestPlateAction } from "@redux/modules";

// Header - Footer
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";

// Components
import GlobalLoader from "@components/GlobalLoader";
import showMessage from "@components/ShowMessage";
import showErrMessage from "@components/ShowErrMessage";

import "./styles.scss";

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

const STATUS_LABEL = {
  WAITING: { text: "Onay Bekliyor", cls: "bp-tag-pending" },
  APPROVED: { text: "Havuzda", cls: "bp-tag-approved" },
  IN_VOTING: { text: "Oylamada", cls: "bp-tag-voting" },
  PUBLISHED: { text: "Yayınlandı", cls: "bp-tag-voting" },
  DENIED: { text: "Reddedildi", cls: "bp-tag-rejected" },
};

const BestPlate = () => {
  const dispatch = useDispatch();

  const votingList = useSelector((store) => store.bestPlate.votingList);
  const myPhotos = useSelector((store) => store.bestPlate.myPhotos);
  const winners = useSelector((store) => store.bestPlate.winners);
  const status = useSelector((store) => store.bestPlate.status);
  const isLoading = useSelector((store) => store.bestPlate.isLoading);

  const uploadLocked = status?.uploadLocked === true;
  const themeName = status?.themeName || null;
  const lockMessage = status?.lockMessage || null;

  const [view, setView] = useState("voting"); // voting | upload | winner

  // Upload form
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [editId, setEditId] = useState(null);

  // Oylama: tıklanan tabağın detay modalı
  const [selectedPlate, setSelectedPlate] = useState(null);

  useEffect(() => {
    dispatch(bestPlateAction.getVotingList());
    dispatch(bestPlateAction.getWinners());
    dispatch(bestPlateAction.getStatus());
  }, []);

  useEffect(() => {
    if (view === "upload") dispatch(bestPlateAction.getMyPlates());
  }, [view]);

  const handleVote = (item) => {
    if (item.own || item.voted) return;
    dispatch(bestPlateAction.doVote(item.competitionId, item.id))
      .then(() => {
        showMessage("Oyunuz kaydedildi!");
        // Modal açıksa içindeki kartı da anında güncelle
        setSelectedPlate((prev) =>
          prev && prev.id === item.id
            ? {
                ...prev,
                voted: true,
                votesReceived: (prev.votesReceived || 0) + 1,
              }
            : prev
        );
        dispatch(bestPlateAction.getVotingList());
      })
      .catch((err) => showErrMessage(err?.message || "Oyunuz kaydedilemedi"));
  };

  // Kazanan (banner / hero / arşiv) için salt-okunur modal (beğeni butonu olmadan)
  const openWinnerModal = (winner) =>
    setSelectedPlate({ ...winner, readOnly: true });

  const handleFileChange = (e) => {
    const selected = e.target.files?.[0];
    if (!selected) return;
    if (selected.size > MAX_FILE_SIZE) {
      showErrMessage(
        "Yüklediğiniz görsel 5MB sınırını aşıyor. Lütfen daha küçük bir dosya seçin."
      );
      e.target.value = ""; // aynı dosya tekrar seçilebilsin
      return;
    }
    setFile(selected);
    setPreview(window.URL.createObjectURL(selected));
  };

  const resetUploadForm = () => {
    setTitle("");
    setDescription("");
    setFile(null);
    setPreview(null);
    setEditId(null);
  };

  const handleUpload = (e) => {
    e.preventDefault();
    if (uploadLocked) return;
    if (!title.trim()) {
      showErrMessage("Başlık zorunludur.");
      return;
    }
    if (!editId && !file) {
      showErrMessage("Lütfen bir fotoğraf seçin.");
      return;
    }
    if (file && file.size > MAX_FILE_SIZE) {
      showErrMessage(
        "Yüklediğiniz görsel 5MB sınırını aşıyor. Lütfen daha küçük bir dosya seçin."
      );
      return;
    }
    dispatch(bestPlateAction.uploadPlate(title, description, file, editId))
      .then(() => {
        showMessage("Fotoğrafınız moderasyon onayına gönderildi.");
        resetUploadForm();
        dispatch(bestPlateAction.getMyPlates());
      })
      .catch((err) => showErrMessage(err?.message || "Fotoğraf yüklenemedi"));
  };

  const startReplace = (item) => {
    setEditId(item.id);
    setTitle(item.title || "");
    setDescription(item.description || "");
    setFile(null);
    setPreview(item.imageUrl || null);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const lastWinner = winners && winners.length > 0 ? winners[0] : null;
  const archive = winners && winners.length > 1 ? winners.slice(1) : [];

  const formatDate = (d) => (d ? new Date(d).toLocaleDateString("tr-TR") : "");

  return (
    <React.Fragment>
      {isLoading ? <GlobalLoader /> : null}
      <Header />

      <div className="bp-page container py-5">
        {/* Tabs */}
        <div className="bp-tabs mb-4">
          <button
            className={`bp-tab ${view === "voting" ? "active" : ""}`}
            onClick={() => setView("voting")}
          >
            🍽️ Oylama
          </button>
          <button
            className={`bp-tab ${view === "upload" ? "active" : ""}`}
            onClick={() => setView("upload")}
          >
            📸 Tabağını Yükle
          </button>
          <button
            className={`bp-tab ${view === "winner" ? "active" : ""}`}
            onClick={() => setView("winner")}
          >
            🏆 Haftanın Birincisi
          </button>
        </div>

        {/* ============ OYLAMA ============ */}
        {view === "voting" && (
          <div>
            <h2 className="bp-title mb-4">Haftanın En İyi Tabakları</h2>

            {lastWinner && (
              <div
                className="bp-winner-banner bp-clickable mb-4"
                role="button"
                onClick={() => openWinnerModal(lastWinner)}
              >
                <div className="bp-winner-img">
                  {lastWinner.imageUrl ? (
                    <img src={lastWinner.imageUrl} alt="" />
                  ) : (
                    "🏆"
                  )}
                </div>
                <div className="flex-grow-1">
                  <div className="bp-winner-label">
                    GEÇEN HAFTANIN BİRİNCİSİ
                  </div>
                  <div className="bp-winner-name">
                    {lastWinner.employeeName} {lastWinner.employeeSurname} —
                    "{lastWinner.title}"
                  </div>
                  <div className="bp-winner-detail">
                    {formatDate(lastWinner.beginDate)} –{" "}
                    {formatDate(lastWinner.endDate)}
                  </div>
                </div>
                <div className="bp-winner-score text-center">
                  <div className="bp-winner-hearts">
                    ❤️ {lastWinner.votesReceived}
                  </div>
                  <div className="bp-winner-hearts-label">beğeni</div>
                </div>
              </div>
            )}

            {votingList && votingList.length > 0 ? (
              <div className="bp-grid">
                {votingList.map((item) => (
                  <div
                    className="bp-card bp-card-clickable"
                    key={item.id}
                    role="button"
                    onClick={() => setSelectedPlate(item)}
                  >
                    <div className="bp-card-img">
                      {item.imageUrl ? (
                        <img src={item.imageUrl} alt="" />
                      ) : (
                        "🍽️"
                      )}
                    </div>
                    <div className="bp-card-body">
                      <div className="bp-card-title">{item.title}</div>
                      <div className="bp-card-user">
                        {item.employeeName} {item.employeeSurname}
                      </div>
                      <div className="bp-card-footer">
                        <button
                          className={`bp-heart ${
                            item.voted ? "liked" : ""
                          } ${item.own ? "disabled" : ""}`}
                          disabled={item.own || item.voted}
                          title={
                            item.own
                              ? "Kendi fotoğrafınızı oylayamazsınız"
                              : item.voted
                              ? "Bu tabağı beğendiniz"
                              : "Beğen"
                          }
                          onClick={(e) => {
                            e.stopPropagation();
                            handleVote(item);
                          }}
                        >
                          {item.voted ? "❤️" : "🤍"}{" "}
                          <span>{item.votesReceived}</span>
                        </button>
                        {item.own ? (
                          <span className="bp-own">Sizin</span>
                        ) : (
                          <span className="bp-score">+{item.score}p</span>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-5 opacity-75">
                <h3>Bu hafta oylamada tabak bulunmuyor</h3>
              </div>
            )}

          </div>
        )}

        {/* ============ YÜKLEME ============ */}
        {view === "upload" && (
          <div>
            <h2 className="bp-title mb-4">
              {editId ? "Fotoğrafı Değiştir" : "Tabağını Yükle"}
            </h2>

            {themeName && !uploadLocked && (
              <div className="bp-theme-banner mb-4">
                🎯 Gelecek haftanın teması: <strong>{themeName}</strong>
                <span className="bp-theme-hint">
                  {" "}
                  — tabağını buna göre hazırla
                </span>
              </div>
            )}

            {uploadLocked && (
              <div className="bp-lock-banner mb-4">
                <div className="bp-lock-icon">🏆</div>
                <div>
                  {lockMessage ||
                    "Tebrikler! Bu ay sahneyi diğer ustalara bırakıyorsunuz — gelecek ay tekrar katılabilirsiniz."}
                  <div className="bp-lock-sub">
                    Oy vermeye devam edebilir, beğenilerinle puan
                    kazanabilirsin.
                  </div>
                </div>
              </div>
            )}

            <form
              onSubmit={handleUpload}
              className={`bp-upload-form mb-4 ${
                uploadLocked ? "bp-upload-form--locked" : ""
              }`}
            >
              <div className="bp-upload-box">
                <input
                  type="file"
                  accept="image/png, image/jpeg"
                  disabled={uploadLocked}
                  onChange={handleFileChange}
                />
                {preview ? (
                  <img src={preview} alt="" className="bp-upload-preview" />
                ) : (
                  <div className="text-center">
                    <div style={{ fontSize: "40px" }}>📸</div>
                    <div>Fotoğrafını seç</div>
                    <small className="opacity-75">JPG, PNG — Max 5MB</small>
                  </div>
                )}
              </div>

              <input
                className="form-control bp-input"
                value={title}
                maxLength={100}
                disabled={uploadLocked}
                placeholder="Tabağınıza bir isim verin *"
                onChange={(e) => setTitle(e.target.value)}
              />

              <div className="bp-desc-wrap">
                <textarea
                  className="form-control bp-desc"
                  value={description}
                  maxLength={300}
                  rows={2}
                  disabled={uploadLocked}
                  placeholder="Tarif veya hikaye ekleyin... (opsiyonel)"
                  onChange={(e) => setDescription(e.target.value)}
                />
                <small
                  className={`bp-char-counter ${
                    description.length >= 300
                      ? "text-danger fw-bold"
                      : description.length >= 270
                      ? "text-warning"
                      : "text-muted"
                  }`}
                >
                  {description.length}/300
                </small>
              </div>

              <div className="d-flex justify-content-between align-items-center">
                <small className="opacity-75">
                  Fotoğrafınız moderasyon onayından sonra havuza eklenecektir.
                </small>
                <div>
                  {editId && (
                    <button
                      type="button"
                      className="btn btn-link text-red me-2"
                      onClick={resetUploadForm}
                    >
                      Vazgeç
                    </button>
                  )}
                  <button
                    type="submit"
                    className="btn btn-green"
                    disabled={uploadLocked}
                  >
                    {editId ? "Güncelle" : "Gönder"}
                  </button>
                </div>
              </div>
            </form>

            <h4 className="mb-3">Fotoğraflarım</h4>
            <div className="table-responsive">
              <table className="table bp-table align-middle">
                <thead>
                  <tr>
                    <th>Fotoğraf</th>
                    <th>Başlık</th>
                    <th>Tarih</th>
                    <th>Durum</th>
                    <th>Beğeni</th>
                    <th>İşlem</th>
                  </tr>
                </thead>
                <tbody>
                  {myPhotos && myPhotos.length > 0 ? (
                    myPhotos.map((p) => {
                      const label = STATUS_LABEL[p.status] || {
                        text: p.statusDisplayName,
                        cls: "",
                      };
                      const editable =
                        (p.status === "WAITING" || p.status === "APPROVED") &&
                        !p.changeRightUsed;
                      return (
                        <tr key={p.id}>
                          <td>
                            {p.imageUrl ? (
                              <img
                                src={p.imageUrl}
                                alt=""
                                className="bp-thumb"
                              />
                            ) : (
                              "🍽️"
                            )}
                          </td>
                          <td>{p.title}</td>
                          <td>{formatDate(p.dateUpload)}</td>
                          <td>
                            <span className={`bp-tag ${label.cls}`}>
                              {label.text}
                            </span>
                          </td>
                          <td>{p.votesReceived ?? "—"}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-outline-secondary"
                              disabled={!editable || uploadLocked}
                              onClick={() =>
                                editable && !uploadLocked && startReplace(p)
                              }
                            >
                              Değiştir
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={6} className="text-center opacity-75 py-4">
                        Henüz fotoğraf yüklemediniz.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* ============ HAFTANIN BİRİNCİSİ ============ */}
        {view === "winner" && (
          <div>
            <h2 className="bp-title mb-4">Haftanın Birincisi</h2>

            {lastWinner ? (
              <div
                className="bp-winner-hero bp-clickable text-center mb-5"
                role="button"
                onClick={() => openWinnerModal(lastWinner)}
              >
                <div className="bp-winner-hero-img">
                  {lastWinner.imageUrl ? (
                    <img src={lastWinner.imageUrl} alt="" />
                  ) : (
                    "🥘"
                  )}
                </div>
                <div className="bp-winner-hero-week">
                  {formatDate(lastWinner.beginDate)} –{" "}
                  {formatDate(lastWinner.endDate)}
                </div>
                <div className="bp-winner-hero-title">"{lastWinner.title}"</div>
                <div className="bp-winner-hero-user">
                  {lastWinner.employeeName} {lastWinner.employeeSurname}
                </div>
                <div className="bp-winner-hero-hearts">
                  ❤️ {lastWinner.votesReceived} beğeni
                </div>
              </div>
            ) : (
              <div className="text-center py-5 opacity-75">
                <h3>Henüz birinci ilan edilmedi</h3>
              </div>
            )}

            {archive.length > 0 && (
              <div className="bp-archive">
                <h4 className="mb-3">Geçmiş Birinciler</h4>
                {archive.map((w) => (
                  <div
                    className="bp-archive-item bp-clickable"
                    key={w.id}
                    role="button"
                    onClick={() => openWinnerModal(w)}
                  >
                    <div className="bp-archive-week">
                      {formatDate(w.beginDate)} – {formatDate(w.endDate)}
                    </div>
                    <div className="bp-archive-img">
                      {w.imageUrl ? <img src={w.imageUrl} alt="" /> : "🍽️"}
                    </div>
                    <div className="bp-archive-name">
                      {w.employeeName} {w.employeeSurname} — "{w.title}"
                    </div>
                    <div className="bp-archive-score">
                      ❤️ {w.votesReceived}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Tabak detay modalı — oylama + kazanan (salt-okunur) için ortak */}
        {selectedPlate && (
          <div
            className="bp-modal-overlay"
            onClick={() => setSelectedPlate(null)}
          >
            <div className="bp-modal" onClick={(e) => e.stopPropagation()}>
              <button
                type="button"
                className="bp-modal-close"
                onClick={() => setSelectedPlate(null)}
              >
                ×
              </button>
              <div className="bp-modal-img">
                {selectedPlate.imageUrl ? (
                  <img src={selectedPlate.imageUrl} alt="" />
                ) : (
                  <span>🍽️</span>
                )}
              </div>
              <div className="bp-modal-body">
                <h3 className="bp-modal-title">{selectedPlate.title}</h3>
                <div className="bp-modal-user">
                  {selectedPlate.employeeName} {selectedPlate.employeeSurname}
                </div>
                {selectedPlate.description ? (
                  <p className="bp-modal-desc">{selectedPlate.description}</p>
                ) : (
                  <p className="bp-modal-desc bp-modal-desc--empty">
                    Açıklama eklenmemiş.
                  </p>
                )}
                <div className="bp-modal-footer">
                  {selectedPlate.readOnly ? (
                    <span className="bp-modal-likes">
                      ❤️ {selectedPlate.votesReceived} beğeni
                    </span>
                  ) : (
                    <>
                      <button
                        className={`bp-heart bp-heart-lg ${
                          selectedPlate.voted ? "liked" : ""
                        } ${selectedPlate.own ? "disabled" : ""}`}
                        disabled={selectedPlate.own || selectedPlate.voted}
                        title={
                          selectedPlate.own
                            ? "Kendi fotoğrafınızı oylayamazsınız"
                            : selectedPlate.voted
                            ? "Bu tabağı beğendiniz"
                            : "Beğen"
                        }
                        onClick={() => handleVote(selectedPlate)}
                      >
                        {selectedPlate.voted ? "❤️" : "🤍"}
                        <span>{selectedPlate.votesReceived}</span>
                        <span className="bp-heart-text">
                          {selectedPlate.voted ? "Beğendiniz" : "Beğen"}
                        </span>
                      </button>
                      {selectedPlate.own ? (
                        <span className="bp-own">Sizin tabağınız</span>
                      ) : (
                        <span className="bp-score">
                          +{selectedPlate.score}p
                        </span>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </React.Fragment>
  );
};

export default BestPlate;
